export enum modalTypes {
	helpModal = 'helpModal',
}